import React, { Component } from "react";
import { Form, Input, Modal, Button, Select, Checkbox } from "antd";
import { connect } from "react-redux";
import { SaveFilled } from "@ant-design/icons";
import { withTranslation } from "react-i18next";
import "./createOrUpdateDoorModal.scss";

const mapDispatchToProps = (dispatch) => {
  return {};
};

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};

const CustomLabel = ({ color, labelText }) => {
  return (
    <span style={{ color: color }}>
      {labelText}
    </span>
  );
};

class ConnectCreateOrUpdateDoorModal extends Component {
  formRef = React.createRef();

  state = {
    modalVisible: this.props.modalVisible || false,
    modalMode: "create",
    selectedDoor: null,
    name: null,
    type: null,
    sensors: [],
    floor: 0,
    isExit: false,
    officeId: null,
    user: null,
    doorTypes: [],
  };

  componentDidMount = async () => {
    this.setState({
      modalVisible: this.props.modalVisible,
      modalMode: this.props.modalMode,
    });
  };

  componentDidUpdate = () => {
    if (this.props.modalVisible !== this.state.modalVisible) {
      this.setState({
        modalVisible: this.props.modalVisible,
        modalMode: this.props.modalMode,
        user: this.props.user,
        doorTypes: this.props.doorTypes,
      });

      if (this.props.selectedDoor) {
        const selectedDoor = this.props.selectedDoor;
        
        this.setState({
          selectedDoor: selectedDoor,
          name: selectedDoor.name,
          type: selectedDoor.type,
          floor: selectedDoor.floor,
          epId: selectedDoor.epId,
          isExit: selectedDoor.isExit,
          sensors: selectedDoor.sensors,
        });

        this.formRef.current.setFieldsValue({
          name: selectedDoor.name,
          type: selectedDoor.type,
          floor: selectedDoor.floor,
          epId: selectedDoor.epId,
          isExit: selectedDoor.isExit,
        });
      }
    }
  };

  handleCancel = () => {
    this.setState({
      name: null,
      type: null,
      floor: 0,
      epId: null,
      isExit: false,
      officeId: null,
      sensors: [],
    });
    this.formRef.current.resetFields();
    this.props.handleCancelModal();
  };

  handleFormFinish = async () => {
    const saveData = {
      id: this.state.selectedDoor?.id || null,
      officeId: null,
      name: this.state.name,
      type: this.state.type,
      floor: this.state.floor,
      epId: this.state.epId,
      isExit: this.state.isExit,
      sensors: this.state.sensors,
    };

    if (this.state.modalMode === "create") {
      await this.props.createDoor(saveData);
    } else {
      await this.props.updateDoor(saveData);
    }
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  changeType = (event) => {
    this.setState({ type: event });
  };

  handleChangeCheckbox = (event) => {
    this.setState({
      [event.target.name]: event.target.checked,
    });
  };

  handleOpenModal = async () => {
    this.setState({
      openSearchModal: true,
    });
  };

  handleChangeSensorEpId = (id, newEpId) => {
    const sensorIndex = this.state.sensors.findIndex(
      (sensor) => sensor.id === id
    );

    if (sensorIndex !== -1) {
      const updatedSensors = this.state.sensors.map((sensor, index) => {
        if (index === sensorIndex) {
          return { ...sensor, epId: newEpId };
        }
        return sensor;
      });

      this.setState({ sensors: updatedSensors });
    }
  };

  render() {
    return (
      <div className="doorModal">
        <Modal
          visible={this.state.modalVisible}
          title={
            this.state.modalMode === "create"
              ? this.props.t("building-layout-door-modal-create-title")
              : this.props.t("building-layout-door-modal-update-title")
          }
          onCancel={this.handleCancel}
          footer={null}
          forceRender
        >
          <Form
            className="modal-body"
            name="modifier"
            onFinish={this.handleFormFinish}
            ref={this.formRef}
            {...formItemLayout}
            scrollToFirstError
          >
            <Form.Item
              label={this.props.t("building-layout-door-modal-name-label")}
              name="name"
              rules={[
                {
                  required: true,
                  message: this.props.t("entrypoints-modal-must-fill"),
                },
              ]}
              hasFeedback
            >
              <Input
                value={this.state.name}
                name="name"
                onChange={this.handleChange}
              />
            </Form.Item>
            {this.state.sensors.map((sensor) => (
              <Form.Item
                key={sensor.id}
                label={
                  <CustomLabel
                    color={sensor.color}
                    labelText={this.props.t("building-layout-door-modal-ep-id-label")}
                  />
                }
                initialValue={sensor.epId}
                name={`epId_${sensor.id}`}
                rules={[
                  {
                    required: true,
                    message: this.props.t("entrypoints-modal-must-fill"),
                  },
                ]}
                hasFeedback
              >
                <Input
                  name={`epId_${sensor.epId}`}
                  onChange={(e) =>
                    this.handleChangeSensorEpId(sensor.id, e.target.value)
                  }
                />
              </Form.Item>
            ))}
            <Form.Item
              label={this.props.t("building-layout-door-modal-type-label")}
              name="type"
              rules={[
                {
                  required: true,
                  message: this.props.t("entrypoints-modal-must-fill"),
                },
              ]}
            >
              <Select
                name="type"
                onChange={(event) => this.changeType(event)}
                value={this.state.type}
              >
                {this.state.doorTypes.map((doorType) => {
                  return (
                    <Select.Option key={doorType.id} value={doorType.id}>
                      {doorType.name}
                    </Select.Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              label={this.props.t("building-layout-door-modal-floor-label")}
              name="floor"
              rules={[
                {
                  required: true,
                  message: this.props.t("entrypoints-modal-must-fill"),
                },
              ]}
            >
              <Input
                value={this.state.floor}
                name="floor"
                type="number"
                onChange={this.handleChange}
              />
            </Form.Item>
            <Form.Item
              label={this.props.t("building-layout-door-modal-is-exit-label")}
              name="isExit"
              initialValue={this.state.isExit}
            >
              <Checkbox
                name="isExit"
                onChange={this.handleChangeCheckbox}
                checked={this.state.isExit}
              />
            </Form.Item>
            <Form.Item
              {...tailFormItemLayout}
              style={{
                textAlign: "right",
                width: "100%",
              }}
            >
              <Button
                key="cancel"
                onClick={this.handleCancel}
                style={{ marginRight: "1em" }}
              >
                {this.props.t("cancel-button-label")}
              </Button>
              <Button type="primary" htmlType="submit">
                <SaveFilled />
                {this.state.modalMode === "create"
                  ? this.props.t(
                      "building-layout-door-modal-create-button-label"
                    )
                  : this.props.t(
                      "building-layout-door-modal-update-button-label"
                    )}
              </Button>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

const CreateOrUpdateDoorModal = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(ConnectCreateOrUpdateDoorModal)
);
export default CreateOrUpdateDoorModal;